import type { ReportHandler } from "web-vitals";
import { ANALYTICS_EVENTS } from "./events";
import { trackAnalyticsEvent } from "./amplitude";

export const sendWebVitalsToAnalytics: ReportHandler = (metric) => {
  const rating = "rating" in metric ? (metric as { rating?: string }).rating : undefined;
  const navigationType =
    "navigationType" in metric ? (metric as { navigationType?: string }).navigationType : undefined;

  trackAnalyticsEvent(ANALYTICS_EVENTS.WEB_VITAL, {
    metric_name: metric.name,
    metric_id: metric.id,
    metric_value: metric.value,
    metric_delta: metric.delta,
    metric_rating: rating,
    navigation_type: navigationType,
  });
};

